<div class="container-fluid" style="overflow-x: hidden;padding: 0px;">
  <!-- Navbar Start Here-->
  <nav class="navbar navbar-expand-lg navbar-light">
    <a class="navbar-brand" href="#">
      <img src="assets/img/fastswifflogo.svg" width="121" class="image1 ml-1 img-fluid" height="32.651"
        alt="FastSwiff Logo">
    </a>
    <ul class="navbar-nav ml-auto d-flex flex-row align-items-center">
      <li class="nav-item">
        <p class="nav-link mt-3 mr-2 paragraph">Already have a FastSwiff account?</p>
      </li>
      <li class="nav-item">
        <app-custom-button text="Sign In" [backgroundColor]="'#09BCE1'" [textColor]="'#fff'" class="mt-2 "
          width="'50%'" (onClick)="onSignIn()" ></app-custom-button>
      </li>
    </ul>
  </nav>
  <!-- Navbar End Here -->

  <div class="container-fluid mt-5">
    <div class="row ">
      <div class="col-md-6 order-md-2 order-sm-1 ">
    <!-- Register -->
    <div class="carosal-card">
      <h1 class="heading2">Easy & Smooth <span class="onboarding">Onboarding Process</span></h1>
      <span class="card-title">Our registration process is quick and simple, requiring very little time.</span>
      <div class="steps" style=" display: flex; flex-direction: column; justify-content: space-between; align-items: center; margin-top: 15px; ">

          <!-- Your Carousel Content start Here -->
          <div class="carousel-container" style="display: flex; flex-direction: row; justify-content: space-between;">
              <div >
                  <div (click)="prevStep()"  style="border-radius: 50%; background-color: #F7F8F8; width: 30px; height: 30px; position: absolute; top: 50%; left: 2%; " >
                      <img src="assets/img/CaretLeft.svg" alt="Left Arrow" style="width: 16px;
                      height: 16px; margin-left: 5px; margin-top: 5px;">
                  </div>
              </div>

              <div class="carousel" >
                  <div *ngFor="let variant of variants; let i = index" class="carousel-item" [class.active]="i === currentStep" style=" margin-left: 20%;">
                      <div class="step-header "
                          style=" color:#333A6E;background-color: #c2c8c9;border-radius: 8px; height: 10%;">
                          <h3 style="text-align: center; font-size: 19px; font-weight: 500;"> {{ variant.step }}</h3>
                      </div>
                      <img [src]="variant.image" alt="Step Image"  class="step-image">
                      <div class="step-content"
                          style="font-size: 18px; font-weight: 500; text-align: center; color: #646F71; height: 150px;">
                          {{ variant.content }}
                      </div>

                  </div>
                  <div class="dots">
                      <span *ngFor="let variant of variants; let i = index" [class.active]="i === currentStep" (click)="goToStep(i)"></span>
                  </div>
              </div>
              <div >
              <div (click)="nextStep()"  style="border-radius: 50%; background-color: #F7F8F8; width: 30px; height: 30px; position: absolute; top: 50%; right: 2%; ">
                  <img src="assets/img/CaretLeft (1).svg" alt="Left Arrow" style="width: 16px;
                  height: 16px; margin-left: 5px; margin-top: 5px;">
              </div>
              </div>

          </div>

          <!-- Your Carousel Content  End Here -->
          <div class="row checkbox">
              <app-custom-checkbox-with-title-and-subtitle title=""
                  textPaddingLeft="15px" checkboxSize="25px" titleFontSize="13px"
                  subtitleFontSize="12px" (onValueChange)="handleChange($event)"
                  [value]="checked"
                  ></app-custom-checkbox-with-title-and-subtitle>
                  <p class="mt-1">I agree to your <a href="https://fastswiff.com/terms-and-conditions.html" style="color: var(--main1);">Terms & Conditions</a>  & <a href="https://fastswiff.com/privacy-policy.html"  style="color: var(--main1);">Privacy Policy</a> to SignUp</p>
          </div>
      </div>
      <div class="SignUp mt-3" style="margin-left:50px;" >
        <app-custom-button text="Sign Up" class="login-button-group" width="80%" [backgroundColor]="'#09BCE1'"
          [textColor]="'#fff'" (onClick)="signUpClick()" [disabled] = "!checked"></app-custom-button>
      </div>
  </div>
      </div>
      <div class="col-md-6 order-md-1 order-sm-2" style="padding-left: 15px;">
        <app-common-card [showSalyLogo]="false"></app-common-card>
      </div>
    </div>
  </div>
</div>



